import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getHistory, GetHistoryParams } from './getHistory';

/** @deprecated Avoid directly use,Use `usePriceHistory` from '@ui/hooks/price/usePriceHistory' instead for single entry point*/
export const useBenchmarkHistory = (params: GetHistoryParams) => {
  const reactQueryOptions = useMemo(() => {
    return queryOptions({
      queryKey: getKey(params),
      queryFn: getFn(params),
    });
  }, [params]);

  return useQuery(reactQueryOptions);
};

const getKey = (params: GetHistoryParams) => {
  return ['pyth-benchmark/history', params];
};
const getFn = (params: GetHistoryParams) => () => getHistory(params);
useBenchmarkHistory.getQueryKey = getKey;
useBenchmarkHistory.getQueryFn = getFn;
